// extracted by mini-css-extract-plugin
export default {"wrapper":"RightSection_wrapper__fuGRO","main":"RightSection_main__SdQ6Y","follow":"RightSection_follow__KHZRt"};